<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>


    <div class="page template-padding pt-2" v-else-if="loaded" >
        
        <div class="d-none" >
            <ul class="horizontal-menu" > 
                <li>  <router-link :to="{name: 'Leads'}" class="not-active" > <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back </router-link>  </li>
            </ul>
        </div>
        
        <div class="col-12" >
            
            <leadDetails :data="data" :type="type" ></leadDetails>
            
        </div>
        
        <div class="page-section col-12 mt-4 p-0" >
            <b-card no-body class="atlass-tabs" >
                <b-tabs card>
                    
                    <b-tab title="Customer Journey" @click="get_data('tags')" >
                        <b-card-text>
                            
                            <spinner v-if="!tabloaded" ></spinner>
                            
                            <tagsComponent v-if="tabloaded && selectedTab == 'tags' " :data="tags" :pageType="pageType" :leadID="docID" ></tagsComponent>
                            
                        </b-card-text>
                    </b-tab>
                    
                    <b-tab title="Clicks" @click="get_data('clicks')" >
                        
                        <spinner v-if="!tabloaded" ></spinner>
                        
                        <clicksComponent v-if="tabloaded " origin="tab" :data="clicks" :allDataLoaded="allClicksLoaded" ></clicksComponent>
                        
                    </b-tab>
                    
                    <b-tab title="Purchases" @click="get_data('orders')" >
                        
                        <spinner v-if="!tabloaded" ></spinner>
                        
                        <leadOrders v-if="tabloaded " :data="orders" :pageType="pageType" ></leadOrders>
                        
                    </b-tab>
                    
                </b-tabs>
            </b-card>
        </div>
        
        <div class="container tab-data"  >
            
        </div>
        
    </div>
</template>

<script>

import leadDetails from './leadDetails.vue' 
import tagsComponent from './tags.vue' 
import clicksComponent from './clicks.vue' 
import leadOrders from './leadOrders.vue' 
import helper from '@/helpers/helpers.js';
    
import Cookies from 'js-cookie'

export default {
    name: 'leadComponent',
    components:{
        tagsComponent,
        clicksComponent,
        leadDetails,
        leadOrders
    },
    props: {
        ID: { 
            type: [String, Object],
        },
        pageType: {
            type: [String],
            default: 'edit'
        }
    },
    data: function(){
        return {
            loaded: false,
            data:{},
            docID: null,
            selectedTab: 'tags',
            tags: [],
            clicks: [],
            allClicksLoaded: false,
            orders: [],
            type: 'component',
            tabloaded: false,
            timeout: 50,
            passedOrganization: null
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
        
    },
    mounted: function () {
        
        if( Cookies.get('user-token') == undefined ){
            this.$parent.fModalClose()
            this.$toast.info({
                title:'Not logged in',
                message: 'You need to log in in order to see lead details'
            })
        }else{

            //IF LOGGED IN
            //console.log( this.$route.name )
            if( this.$route.name == 'OrgLeads' ){
                this.passedOrganization = this.$route.params.passed_organizationID
            }
            if( this.$route.name == 'OrgEvents' ){
                this.passedOrganization = this.$route.params.ID
            }

            //console.log(this.ID)
            if( typeof this.ID == 'string' ){
                //console.log("string")
                this.docID = this.ID
                this.get_lead();

            }else if( this.ID.leadID ){
                //console.log("obj")
                //CLICK CAME FROM LEAD CONVERSIONS
                //LOAD BASED ON leadID
                this.docID = this.ID.leadID
                this.get_lead();
            }else{
                //console.log("lead")
                //CLICK CAME FROM LEADS
                this.data = this.ID
                this.docID = this.ID.id
                //this.setCreatedTag( this.data )
                this.getTags();
            }
            //IF LOGGED IN
            
        }

    },
    beforeDestroy() {
        
    },
    methods: {
        setCreatedTag( lead ){
            
            let optinTag = {                        
                datetime: lead.datetime_created,
                leadID: lead.id,
                name: "Lead was created",
                origin: "ATLASS",
                origin_type: "BOT",
                tag: " opted in ",
                type: 0
            }

            this.tags.push( optinTag )
            
        },
        
        get_lead(){
                        
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin, this.passedOrganization )

            //console.log(orgID)
            //console.log(this.docID)
            
            const db = this.$firebase.firestore();
            var ref = db.collection('organizations/'+orgID+'/leads').doc( this.docID )

            return ref.get()
                .then((snapshot) => {
                    if( snapshot.data() == undefined ){
                        
                        //console.log(this)

                        this.$toast.info({
                            title:'Not found',
                            message: 'Lead not found, deleted from database'
                        })
                        this.$parent.fModalClose()

                    }else{
                        if( snapshot.data().mergedLead ){
                            console.log( "Merged lead: "+ snapshot.data().mergedLead )
                            this.docID = snapshot.data().mergedLead
                            this.get_lead()
                        }else{
                            this.data = snapshot.data()
                            this.data.id = snapshot.id

                            this.getTags();
                        }
                            
                    }                     
                
                    //SET lead was created tag
                    //this.setCreatedTag( this.data )
            })
            
        },

        get_data( t ){
            
            
            //console.log(t)
            this.selectedTab = t;
            if( t == 'tags' ){
                this.tabloaded = false
                this.tags = []
                this.getTags();
            }else if( t == 'clicks' ) {
                
                if( this.clicks.length == 0 ){
                    this.tabloaded = false
                    this.getClicks()
                }else{
                    let startAtDoc = this.clicks[ this.clicks.length - 1 ].datetime
                    this.getClicks( startAtDoc )
                }
                
            }else if( t == 'orders' ){
                this.tabloaded = false
                this.getOrders();
            }
            
        },
        
        getTags(){
                        
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin, this.passedOrganization )
            //console.log(orgID)
            const db = this.$firebase.firestore();
            var ref = db.collection('organizations/'+orgID+'/leads/'+this.docID+'/tags').orderBy('datetime', 'desc');

            return ref.get()
                .then((snapshot) => {
                    
                    let results = [];
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.id = doc.id;
                                results.push( item )
                                //console.log(item)
                                
                                this.tags = results
                                setTimeout(function(){ 
                                    this.loaded = true
                                    this.tabloaded = true
                                }.bind(this), this.timeout );
                            
                                return results;
                        })
                    )
                    

                })
                .then(results => {                        
                    //return results;         
                    this.loaded = true
                    this.tabloaded = true
                })
            
        },
        
        getClicks( startAtDoc = null ){
              
            //FROM CLICKS
            /*
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin, this.passedOrganization )
            const db = this.$firebase.firestore();
            
            var ref = db.collection('organizations/'+orgID+'/leads/'+this.docID+'/clicks').orderBy('datetime', 'desc');

            return ref.get()
                .then((snapshot) => {
                    let results = [];
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.id = doc.id;
                                results.push( item )
                                //console.log(item)
                                
                                this.clicks = results
                                //this.loaded = true;
                                
                                
                            
                                return results;
                        })
                    )
                    .then(results => {                        
                        //return results;       
                        this.tabloaded = true
                    })

                })
            */
            
            //FROM EVENTS
            /*
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin, this.passedOrganization )
            
            var ref = this.$firebase.firestore().collection('organizations/'+orgID+'/events/').where( 'leadID', "==", this.docID )

            
            return ref.get()
                .then((snapshot) => {
                    let results = [];
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.id = doc.id;
                                if( item.type == "CLICK" ){
                                    results.push( item )
                                }
                                
                                //console.log(item)
                                
                                results.sort((a, b) => b.datetime - a.datetime);
                                this.clicks = results
                                
                            
                                return results;
                        })
                    )
                    .then(results => {                        
                        //return results; 
                        this.tabloaded = true
                    })

                })
            */
            //LAZY LOAD FROM EVENTS
            //console.log( startAtDoc )
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin, this.passedOrganization )
            
            const db = this.$firebase.firestore();
            //var ref = db.collection('organizations/'+orgID+'/leads/'+this.ID+'/clicks').orderBy('datetime', 'desc');
            var ref
            let limit = 50
            
            if( startAtDoc == null ){
                ref = db.collection('organizations/'+orgID+'/events/').where( 'leadID',"==",this.docID ).orderBy('datetime', 'desc').limit(limit)
            }else{
                console.log("start After " + startAtDoc )
                ref = db.collection('organizations/'+orgID+'/events/').where( 'leadID',"==",this.docID ).orderBy('datetime', 'desc').startAfter( startAtDoc ).limit(25)
            }
            
            return ref.get()
                .then((snapshot) => {
                    let results = [];
                                    
                    if( snapshot.docs.length == 0 || ( startAtDoc == null && snapshot.docs.length < limit ) ){
                        this.allClicksLoaded = true
                    }
                
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.id = doc.id;
                                if( item.type == "CLICK" ){
                                    results.push( item )
                                    this.clicks.push( item )
                                    //console.log(item)
                                }

                                return results;
                        })
                    )
                    .then(results => {
                        this.tabloaded = true;
                    })

                })
            
        },
        
        setDataLoadedOnChild(component){
            
            //console.log(component)
                        
            component.$children.forEach((child)=>{
                //console.log(child)
                if( 'allDataLoaded' in child ){       
                    console.log("found")
                    child.allDataLoaded = true
                    this.$toast.warn({
                        title: 'Nothing more to load',
                        message:  'All clicks have been loaded'
                    })
                }else{
                    //console.log(child.$children)
                    if( child.$children.length > 0 ){
                        //console.log("child "+ child._uid +" has children. Parse them")
                        //console.log(child.$children)
                        this.setDataLoadedOnChild( child )
                    }else{
                        //console.log("child "+ child._uid +"  does not have children")
                    }
                }
            })
        
        },
        
        
        
        getOrders(docID){
                        
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin, this.passedOrganization )
            const db = this.$firebase.firestore();
            var ref = db.collection('organizations/'+orgID+'/orders').where('leadID', '==', this.docID ).orderBy('datetime', 'desc');

            return ref.get()
                .then((snapshot) => {
                    let results = [];
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                //console.log(doc)
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.id = doc.id;
                                results.push( item )
                                
                                this.orders = results
                                //this.loaded = true;
                                
                                return results;
                        })
                    )
                    .then(results => {                        
                        //return results;   
                        this.tabloaded = true
                    })

                })
            
        },
        
    },
    watch: {
        docID: function(){
            if( typeof this.ID == 'string' ){
                this.docID = this.ID
                this.get_lead();
            }else{
                this.data = this.ID
            }
    
            //this.$refs.tags.$el.click()
            
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped >
    
</style>



// WEBPACK FOOTER //
// src/components/lead.vue